import { Abacus } from "core/Abacus.Core";
import { Class } from "core/Abacus.Utilities";

let AttachmentsViewOptions = {
  buttons: {
    previous: ".controls .previous",
    next: ".controls .next"
  },
  loading: {
    initalLoad: ".main .sleeve, .side .sleeve, li.next, li.previous",
    others: ".side .sleeve, li.next, li.previous",
    name: "loading"
  },
  caption: {
    wrapper: ".caption",
    heading: ".heading",
    description: ".description",
    source: ".source",
    creditText: "span.credit"
  },
  advert: "#attachments-advert",
  counter: ".current-index"
};

class AttachmentsView extends Class {
  setupKeyEvents() {
    var self = this;
    this.element.keyup(function(evt) {
      switch (evt.which) {
        case 27: // Esc Key
          $(window).trigger("abacus:closeAll", [false]);
          break;
        case 37: // Left Key
          self.element.find(self.options.buttons.previous).trigger("click");
          break;
        case 39: // Right Key
          self.element.find(self.options.buttons.next).trigger("click");
          break;
      }
    });
  }

  addLoaders(el) {
    this.element.find(el).addClass(this.options.loading.name);
  }

  removeLoaders(el) {
    this.element.find(el).removeClass(this.options.loading.name);
  }

  checkButtons(index, slides) {
    this.checkStart = index <= 0 ? true : false;
    this.checkEnd = index >= slides - 1 ? true : false;
    this.checkStart
      ? this.element.find(this.options.buttons.previous).addClass("disabled")
      : this.element
          .find(this.options.buttons.previous)
          .removeClass("disabled");
    this.checkEnd
      ? this.element.find(this.options.buttons.next).addClass("disabled")
      : this.element.find(this.options.buttons.next).removeClass("disabled");
  }

  createCaption(caption) {
    var heading = caption.heading,
      description = caption.description,
      source = caption.source,
      creditLink = caption.credit.link,
      creditText = caption.credit.linktext,
      wrapperElement = this.element.find(this.options.caption.wrapper),
      headingElement = wrapperElement.find(
        " > " + this.options.caption.heading
      ),
      descriptionElement = wrapperElement.find(
        " > " + this.options.caption.description
      ),
      sourceElement = wrapperElement.find(" > " + this.options.caption.source),
      sourceElementText = wrapperElement.find(
        " > " + this.options.caption.source + " > span"
      ),
      sourceCreditElement = sourceElement.find(" > a");

    // Same validation required
    this.validateCaption(heading, headingElement);
    this.validateCaption(description, descriptionElement);

    // Different type of validation
    $(this.options.caption.creditText).remove();

    sourceElement.find(".creditLink").remove();
    sourceElement.find(".credit").remove();
    sourceElement.removeClass("empty");
    if (caption.credit.link) {
      sourceElement.append(
        `<a href="${caption.credit.link}" class="creditLink">${
          caption.credit.linktext
        }</a>`
      );
    } else {
      sourceElement.append(`<span class="credit">${creditText}</span>`);
    }
    if (!caption.credit.linktext > 0) sourceElement.addClass("empty");
  }

  validateCaption(text, el) {
    if (text.length > 0) {
      el.html(text);
      el.removeClass("empty");
    } else {
      el.addClass("empty");
    }
  }

  updateAdvert() {
    this.element.find(".side").removeClass("hasAdvert");
    if (this.element.find(this.options.advert)) {
      this.element
        .find(this.options.advert)
        .parent(".side")
        .addClass("hasAdvert");
      this.element
        .find(this.options.advert)
        .html(this.element.find(this.options.advert).html());
    }
  }

  updateCounter(index) {
    this.element.find(this.options.counter).text(index + 1);
  }
}

export { AttachmentsView, AttachmentsViewOptions };



// WEBPACK FOOTER //
// ./Javascript/core/classes/attachments/attachments.view.class.js